/* ==========================================================================
   DAZI unified collection filter bar — behaviour
   Accessible disclosure pattern. Progressive enhancement: with JavaScript
   disabled the panels stay open and every control still works, because the
   whole bar is a plain GET <form> plus ordinary links.
   ========================================================================== */
(function () {
  'use strict';

  var FOCUS_FLAG = 'dzFilterBarFocusResults';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function initBar(bar) {
    if (!bar || bar.hasAttribute('data-dz-fb-ready')) return;
    bar.setAttribute('data-dz-fb-ready', 'true');

    var facets = [].slice.call(bar.querySelectorAll('[data-dz-facet]'));
    if (!facets.length) return;

    var pointerInside = false;

    var items = facets
      .map(function (facet) {
        var trigger = facet.querySelector('[data-dz-trigger]');
        var panel = facet.querySelector('[data-dz-panel]');
        if (!trigger || !panel) return null;
        return { facet: facet, trigger: trigger, panel: panel };
      })
      .filter(Boolean);

    function close(item, returnFocus) {
      if (item.trigger.getAttribute('aria-expanded') !== 'true') return;
      item.trigger.setAttribute('aria-expanded', 'false');
      item.panel.hidden = true;
      if (returnFocus) item.trigger.focus();
    }

    function closeAll(except) {
      items.forEach(function (item) {
        if (item !== except) close(item, false);
      });
    }

    function open(item) {
      closeAll(item);
      item.trigger.setAttribute('aria-expanded', 'true');
      item.panel.hidden = false;
    }

    items.forEach(function (item) {
      // Start closed. (Markup ships open so no-JS users keep access.)
      item.trigger.setAttribute('aria-expanded', 'false');
      item.panel.hidden = true;

      item.trigger.addEventListener('click', function () {
        if (item.trigger.getAttribute('aria-expanded') === 'true') {
          close(item, false);
        } else {
          open(item);
        }
      });

      // Escape closes the panel and puts focus back on its trigger.
      item.facet.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          if (item.trigger.getAttribute('aria-expanded') === 'true') {
            event.stopPropagation();
            close(item, true);
          }
        }
      });

      // Tabbing past the last control in a panel closes it and lets focus
      // continue naturally down the page — no keyboard trap, no loop.
      item.facet.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (pointerInside) return;
          var active = document.activeElement;
          if (!active || !item.facet.contains(active)) {
            close(item, false);
          }
        }, 0);
      });

      // Guard: a mousedown inside the panel must not close it before the
      // click on a swatch or checkbox lands.
      item.panel.addEventListener('pointerdown', function () {
        pointerInside = true;
      });
      item.panel.addEventListener('pointerup', function () {
        pointerInside = false;
      });

      // "Clear" inside a panel unchecks that facet's boxes without leaving.
      var reset = item.panel.querySelector('[data-dz-reset]');
      if (reset) {
        reset.addEventListener('click', function () {
          var boxes = item.panel.querySelectorAll('input[type="checkbox"]');
          [].forEach.call(boxes, function (box) {
            box.checked = false;
          });
          var numbers = item.panel.querySelectorAll('input[type="number"]');
          [].forEach.call(numbers, function (input) {
            input.value = '';
          });
          var first = item.panel.querySelector('input:not([type="hidden"])');
          if (first) first.focus();
        });
      }
    });

    // Click anywhere outside the bar closes any open panel.
    document.addEventListener('click', function (event) {
      if (!bar.contains(event.target)) closeAll(null);
    });

    // Remember that the next page load came from applying a filter, so we can
    // move focus to the results instead of stranding it at the top of the page.
    var form = bar.querySelector('[data-dz-form]');
    if (form) {
      form.addEventListener('submit', function () {
        // Blank price boxes would otherwise add empty params to the URL.
        var numbers = form.querySelectorAll('input[type="number"]');
        [].forEach.call(numbers, function (input) {
          if (input.value === '') input.disabled = true;
        });

        try {
          window.sessionStorage.setItem(FOCUS_FLAG, '1');
        } catch (error) {
          /* Storage blocked (private mode). Non-fatal. */
        }
      });

      // Changing sort re-runs the same query with filters intact.
      var sort = form.querySelector('[data-dz-sort]');
      if (sort) {
        sort.addEventListener('change', function () {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        });
      }
    }
  }

  function restoreFocus() {
    var flagged = false;
    try {
      flagged = window.sessionStorage.getItem(FOCUS_FLAG) === '1';
      if (flagged) window.sessionStorage.removeItem(FOCUS_FLAG);
    } catch (error) {
      return;
    }
    if (!flagged) return;

    var anchor = document.querySelector('[data-dz-results-anchor]');
    if (anchor) anchor.focus();
  }

  ready(function () {
    [].forEach.call(document.querySelectorAll('[data-dz-filter-bar]'), initBar);
    restoreFocus();
  });
})();
